import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { SharedDataAccessAuthorizationApiModule } from "@codman/shared/data-access-authorization-api";

@NgModule({
    imports: [CommonModule, SharedDataAccessAuthorizationApiModule],
})
export class SharedDataAccessAuthorizationModule {}
